import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';

type Props = {
  className?: string;
  showTimeEntryLabel: boolean;
  i18prefix: string;
};

const DayTimeInputLabels: React.FC<Props> = ({
  className,
  showTimeEntryLabel,
  i18prefix,
}) => {
  const t = useNamespacedTranslation(i18prefix);

  return (
    <Row className={className}>
      {showTimeEntryLabel && (
        <Col lg={2} xs={3}>
          <Form.Label className="mb-0">
            {t('timeEntries.form.timeEntryLabel')}
          </Form.Label>
        </Col>
      )}
      <Col lg={showTimeEntryLabel ? 7 : 9} xs={showTimeEntryLabel ? 7 : 9}>
        <Form.Label className="mb-0">
          {t('timeEntries.form.projectsLabel')}
        </Form.Label>
      </Col>
      <Col lg={2} xs={2}>
        <Form.Label className="mb-0">
          {t('timeEntries.form.hoursLabel')}
        </Form.Label>
      </Col>
    </Row>
  );
};

export default DayTimeInputLabels;
